import { Deserializable } from '../protocols/deserializable';
import { CommentMention } from './comment-mention';

export class BaseCommentRequest implements Deserializable {
  public comment: string = '';
  public mentions: CommentMention[] = [];
  onDeserialize = () => {};
}
